import { useContext } from "react";
import { AuthContext, IAuthContext } from "../../context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import Dashboard from "../dashboard/Dashboard";
import DefaultHomePage from "../default/DefaultHomePage";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { useFeatureFlagToken } from "../../hooks/useFeatureFlag";
import { FeatureFlagName } from "../../types/feature-flags/featureFlag";

const Home = () => {
  const { t } = useTranslation("common");
  const { user, validating, authenticated } = useContext(
    AuthContext
  ) as IAuthContext;
  const navigate = useNavigate();
  const hasV2UI = useFeatureFlagToken(FeatureFlagName.V2UI);

  if (validating) {
    return <>{t("common:loading")}</>;
  }

  if (!authenticated || !user) {
    return <Navigate to="/login" />;
  }

  if (hasV2UI && user) {
    navigate(`/customers/${user.customerId}/v2`, { replace: true });
    return null;
  }

  return user.hasPermission(`interactions:Read`) ? (
    <Dashboard />
  ) : !user?.roleId ? (
    <>
      <Typography variant="h6" textAlign="center">
        You do not have an assigned role.
      </Typography>
      <Typography textAlign="center">
        Please contact your administrator to assign you a role.
      </Typography>
    </>
  ) : (
    <DefaultHomePage />
  );
};

export default Home;
